import { wpApi } from "../utils/constants";
const axios = require('axios').default;

export async function fetchAPI(
    query = "",
    { variables } = {}
  ) 
  {  
        return new Promise((resolve, reject) => {
            axios({
                method : "POST",
                url :  wpApi,
                data : JSON.stringify({
                    query,
                    variables,
                }),
                headers:  { "Content-Type": "application/json"},
            })
            .then(
                (response) => {
                    if (response.errors) {
                        console.error(response.errors);
                        throw new Error("Failed to fetch API");
                    }
                    resolve(response.data.data);
                }, (error) => {
                    console.log(error); 
                    reject({posts: { nodes: []}});
                }
            )
        })

      // try {
      //     const headers = { "Content-Type": "application/json" };

      //     const res = await fetch(wpApi, {
      //       headers,
      //       method: "POST",
      //       body: JSON.stringify({
      //         query,
      //         variables,
      //       }),
      //     });

      //     const json = await res.json();
      //     if (json.errors) {
      //       console.error(json.errors);
      //       throw new Error("Failed to fetch API");
      //     }
      //     return json.data;
      // } catch (error) {
      //     // TypeError: Failed to fetch
      //     console.log(error)
      //     return {posts: { nodes: []}}
      // }
  }